import { ACTIVE_FLAGS } from '../init';
export const isFeatureFlagEnabled = (key) => ACTIVE_FLAGS ? (ACTIVE_FLAGS[key] ?? false) : undefined;
